export default __webpack_public_path__ + "static/pic04-3a32a8174e8c02beff600c2e5048105f.jpg";